<template>
  <div>

    <!-- Main Home Page -->
    <section class="main-page">
      <div class="content">
        <div class="textBox">
          <h2 v-html="$t('main.home.'+appName+'.title')"></h2>
          <p style="font-size:1.2em">{{ $t('main.home.' + appName + '.body') }}</p>
          <a href="#">{{ $t('main.home.link') }}</a>
        </div>
        <div class="imgBox d-none d-md-flex">
          <v-img :src="adCar.img" class="mainCar" alt="voiture"></v-img>
        </div>
      </div>
      <ul class="thumb_cars">
        <li v-for="adCar of pictures" :key="adCar.name">
          <img :src="adCar.img" @click="changeAdCar(adCar)" :alt="adCar.name">
        </li>
      </ul>
    </section>

    <!-- AvailabilityForm -->
    <v-card>

      <v-tabs centered id="book" v-model="selectedTab">
        <v-tab v-if="uiConf.enableBookingUI"> {{ $t('main.availability_form.title') }}</v-tab>
        <v-tab-item v-if="uiConf.enableBookingUI">
          <v-card flat>
            <v-card-text>
              <AvailabilityForm/>
            </v-card-text>
          </v-card>

        </v-tab-item>

        <v-tab v-if="uiConf.enableActivitiesUI">{{ $t('shared.activities.title') }}</v-tab>
        <v-tab-item v-if="uiConf.enableActivitiesUI">
          <v-card flat>
            <v-card-text>
              <ActivityForm/>
            </v-card-text>
          </v-card>

        </v-tab-item>
      </v-tabs>

    </v-card>
  </div>
</template>

<script>

import { alger, caribbean, stbarthrental } from '@/shared/data'
import { mapGetters } from 'vuex'
import { VTab } from 'vuetify/lib/components'

export default {
  name: 'Home',
  data: () => ({
    selectedTab: 'activity'
  }),
  methods: {
    changeAdCar (adCar) {
      this.$store.commit('main/setAdCar', adCar)
    }
  },

  computed: {
    pictures: function () {
      console.log('calculate', this.appName, caribbean)
      if (this.appName) {
        switch (this.appName) {
          case 'caribbean':
            return caribbean
          case 'alger' :
            return alger
          case 'stbarthrental' :
            return stbarthrental
          default :
            return alger
        }
      } else {
        return []
      }
    },
    ...mapGetters({ appName: 'main/appName', uiConf: 'main/uiConf' }),
    ...mapGetters({ adCar: 'main/adCar' })
  },
  mounted () {
    if (this.$route.query.activityUuid) {
      this.selectedTab = 1
    }

  }
}
</script>

<style scoped>
.content {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.content .textBox {
  position: relative;
  max-width: 600px;
}

.content .textBox h2 {
  color: #333;
  font-size: 4em;
  line-height: 1.4em;
  font-weight: 500;

}

.content .textBox h2 span#brand {
  color: #2196F3;
  font-size: 1.2em;
  font-weight: 900;
}

.content .textBox p {
  color: #333;
}

.content .textBox a {
  display: inline-block;
  text-decoration: none;
  color: white;
  background: indigo;
  border-radius: 40px;
  padding: 8px 20px;
  margin-top: 20px;
  font-weight: 500;
  letter-spacing: 1px;
}

.content .imgBox {
  width: 600px;
  display: flex;
  justify-content: flex-end;
  padding-right: 50px;
}

.thumb_cars {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  display: flex;
}

.thumb_cars li {
  list-style: none;
  display: inline-block;
  margin: 0 20px;
  cursor: pointer;
  transition: .5s;
}

.thumb_cars li:hover {
  transform: translateY(-15px);
}

.thumb_cars li img {
  max-width: 60px;
}

.sn {
  position: absolute;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.sn li {
  list-style: none;
}

.sn li a {
  display: inline-block;
  margin: 5px 0;
  transform: scale(0.6);
  filter: invert(1);
}

.sn li a:hover {
  transition: .5s;
  transform: scale(0.8);
}

.sn li img {
  max-width: 40px;
}

.imgBox img {
  max-width: 33rem;
}

.textBox h2 {
  font-size: 2rem !important;
}

/* .content .imgBox img{
  max-width: 340px;
} */
.main-page {
  min-height: calc(44vh - 64px);
  max-height: calc(66vh - 64px);
}
</style>
